import { Directive, Input, inject } from '@angular/core'
import { ElderAutoSelectFirstDirective, ElderSelectComponent, Filter } from '@elderbyte/ngx-starter'
import { WorkOrderService } from '../work-order.service'
import { WorkOrderFilterBuilder } from '../work-order-filter-builder'

@Directive({
  selector: '[appWorkOrderSelect]',
})
export class WorkOrderSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  @Input()
  public excludeIds: string[]
  private select = inject(ElderSelectComponent)
  private autoSelect = inject(ElderAutoSelectFirstDirective, { optional: true })

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const workOrderService = inject(WorkOrderService)
    this.select.displayProperty = 'id'
    this.select.placeholder = 'orders.work.order'
    this.select.dataSource = workOrderService
    this.select.isOptionDisabledFn = (option) => {
      return this.excludeIds ? this.excludeIds.includes(option.id) : false
    }
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set prodOrderId(orderId: string) {
    this.workOrderFilters = orderId ? [WorkOrderFilterBuilder.prodOrders(orderId)] : []
  }

  @Input()
  public set workOrderFilters(filters: Filter[]) {
    this.select.updateFilters(filters)
    if (this.autoSelect?.enabled) {
      this.autoSelect.forceReloadFirst()
    }
  }
}
